import { store } from '@/store/store'
import BaseMixin from './base.mixin'
import CONSTANTS from '@/shared/constants/constants'
import { buildQueryFilters } from '@/shared/utils/build-query-filters'
import { buildQueryParams } from '@/shared/utils/build-query-params'

const mixin = {
  mixins: [
    BaseMixin
  ],
  methods: {
    getWorkTimes () {
      return [
        {
          id: CONSTANTS.WORK_TIMES.COMERCIAL,
          value: this.$i18n.t('business_hours')
        },
        {
          id: CONSTANTS.WORK_TIMES['24_7'],
          value: '24 X 7'
        }
      ]
    },
    getSlaUnits () {
      return [
        {
          id: CONSTANTS.SLA_UNIT.HOURS,
          value: this.$i18n.tc('hour', 2)
        },
        {
          id: CONSTANTS.SLA_UNIT.MINUTES,
          value: this.$i18n.tc('minute', 2)
        }
      ]
    },
    async getUsers (filters = null) {
      const url = '/atena/admin/user'

      if (!filters) {
        const data = await this.requestGet(url)
        return data
      }

      let queryFilters = Object.keys(filters).map((key) => {
        return `${key}=${filters[key].value}`
      })

      queryFilters = queryFilters.join('&')

      const data = await this.requestGet(`${url}?${queryFilters}`)
      return data
    },
    getDetailsUser (id) {
      return this.requestGet(`/atena/admin/user/details-simple/${id}`)
    },
    getRolesMessenger () {
      return new Promise(async (resolve) => {
        if (!store.state.rolesMessenger || !store.state.rolesMessenger.length) {
          const rolesMessenger = await this.requestGet('/atena/admin/role/messenger')
          store.dispatch('setRolesMessenger', rolesMessenger)
          return resolve(rolesMessenger)
        }

        return resolve(store.state.rolesMessenger)
      })
    },
    getRolesFilter () {
      return new Promise(async (resolve) => {
        if (!store.state.rolesFilter || !store.state.rolesFilter.length) {
          const url = '/atena/admin/role/withUser'
          const rolesFilter = await this.requestGet(url)
          const adaptedRolesFilter = rolesFilter.map(role => ({
            ...role,
            name: role.roleName
          }))
          store.dispatch('setRolesFilter', adaptedRolesFilter)
          return resolve(adaptedRolesFilter)
        }
        return resolve(store.state.rolesFilter)
      })
    },
    getRoles () {
      return new Promise(async (resolve) => {
        if (!store.state.roles || !store.state.roles.length) {
          const url = '/atena/admin/role'
          const roles = await this.requestGet(url)
          store.dispatch('setRoles', roles)
          return resolve(roles)
        }

        return resolve(store.state.roles)
      })
    },
    getIconByRole (name) {
      const roleIcons = store.state.roleIcons
      const index = roleIcons.findIndex((role) => {
        return role.name === name
      })

      let roleIcon
      if (index === -1) {
        roleIcon = {
          name,
          htmlTag: ''
        }

        try {
          const svg = `/admin/assets/svg/${name}.svg`
          roleIcon.htmlTag = `<img class='user-role-icon-primary' src='${svg}'/>`
        } catch (error) {
          roleIcon.htmlTag = ''
        } finally {
          store.dispatch('setRoleIcon', roleIcon)
        }
      } else {
        roleIcon = roleIcons[index]
      }

      return roleIcon.htmlTag
    },
    async resetPassword (username, options = {}) {
      const payload = {
        username,
        reset2fa: !!options.reset2fa
      }
      const res = await this.requestPost('/atena/admin/user/reset', payload)
      return res.data.password
    },
    addUser (user) {
      if (user.cpf) {
        user.cpf = user.cpf.replace(/\D/g, '')
      }

      return this.requestPost('/atena/admin/user', user)
    },
    addSource (source) {
      return this.requestPost('/core/Administrator/ExamSource', source)
    },
    async getSources (filters) {
      const url = '/core/Administrator/ExamSource/Search'
      if (!filters) {
        return this.requestGet(url)
      }

      let queryFilters = Object.keys(filters).map(key => {
        return `${key}=${filters[key].value}`
      })

      queryFilters = queryFilters.join('&')
      const res = await this.requestGet(`${url}?${queryFilters}`)
      return res.data
    },
    async getPhysicians (filters) {
      const url = '/atena/admin/physician'

      if (!filters) return await this.requestGet(url)

      const queryParams = buildQueryParams(filters)

      return await this.requestGet(`${url}?${queryParams}`)
    },
    async getPhysiciansGetBy (filters) {
      const url = '/core/Administrator/Physicians/GetBy'

      if (!filters) return await this.requestGet(url)

      const queryParams = buildQueryParams(filters)

      return await this.requestGet(`${url}?${queryParams}`)
    },
    async getExams (filters) {
      const url = '/core/Administrator/Exams'
      if (!filters) {
        return this.requestGet(url)
      }

      const queryFilters = buildQueryFilters(filters)
      const res = await this.requestGet(`${url}?${queryFilters}`)
      return res.data
    },
    getExamDetails (examId) {
      return this.requestGet(`/core/Administrator/Exams/Details?examId=${examId}`)
    },
    updatePatientName (examId, name) {
      return this.requestPut(`/core/ExamSource/Exams/${examId}`, { name })
    },
    changePhysician (examId, physicianId) {
      return this.requestPut('/core/Administrator/Exams/ChangePhysician', { examId, physicianId })
    },
    getPhysiciansForExam (examId, page, pageSize, search) {
      let url = `/core/Administrator/Exams/PhysiciansForExam?examId=${examId}`
      if (page) {
        url += `&page=${page}`
      }

      if (pageSize) {
        url += `&pageSize=${pageSize}`
      }

      if (search) {
        url += `&physicianName=${search}`
      }

      return this.requestGet(url)
    },
    cancelExam (examId, reason) {
      return this.requestPut('/core/Administrator/Exams/Cancel', { examId, reason })
    },
    getExamFile (examFileId, type = 'application/pdf') {
      return this.requestGetBlob(`/core/Administrator/Exams/File?examFileId=${examFileId}`, type)
    },
    showLaudo (exameId) {
      return this.requestGetBlob(`/core/ExamSource/Exams/${exameId}/Report`)
    },
    async getPhysiciansForAnalyst (page, limit, search, specialityId) {
      const res = await this.requestGet(`/core/Analyst/Physicians?page=${page}&pageSize=${limit}&search=${search}&specialityId=${specialityId}`)
      return res.data
    },
    getDetailsApp (id) {
      return this.requestGet(`/atena/admin/app/details/${id}`)
    },
    async getUrgencyAlerts (id) {
      const res = await this.requestGet(`core/UrgencyAlert/GetUrgencyAlertsForAdmin?examId=${id}`)
      return res.data
    },
    getAssignExamType() {
      return this.requestGet('/core/Administrator/Physician/AssignExamType')
    }
  }
}

export default mixin
